import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formRenderer: {},
  ProfileFieldsJSON: {},
  ProfileLayoutJSON: [],
  ProfileInfoData: {},
  dropdownData: [],
};

const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formRenderer = action.payload;
    },
    setProfileFieldsJSON: (state, action) => {
      state.ProfileFieldsJSON = action.payload;
    },
    setProfileLayoutJSON: (state, action) => {
      state.ProfileLayoutJSON = action.payload;
    },
    setProfileInfoData: (state, action) => {
      state.ProfileInfoData = action.payload;
    },
    setDropdownData: (state, action) => {
      state.dropdownData = action.payload;
    },
  },
});
export const {
  setFormData,
  setProfileFieldsJSON,
  setProfileLayoutJSON,
  setProfileInfoData,
  setDropdownData
} = profileSlice.actions;

export default profileSlice.reducer;
